// removeGroupBy — VQE-Edit edit-action: drop one GROUP BY entry by 0-based
// list index via SR-Edit's `remove-group-by` op. When the list shrinks to
// zero, SR-Edit also drops the `GROUP BY` keyword. This module just validates
// the index against an optional structure and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/remove GROUP BY.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type RemoveGroupByOptions = {
  /**
   * Optional structure used for index-bounds validation. Surfaces a friendlier
   * error than SR-Edit's silent drop when the list is empty or the index is
   * out of range.
   */
  readonly structure?: QueryStructure;
};

export async function removeGroupBy(
  index: number,
  ctx: CommitEditCtx,
  options: RemoveGroupByOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`removeGroupBy: index must be a non-negative integer (got ${index})`);
  }
  if (options.structure) {
    const items = options.structure.groupBy ?? [];
    if (items.length === 0) {
      throw new Error('removeGroupBy: GROUP BY list is empty');
    }
    if (index >= items.length) {
      throw new Error(
        `removeGroupBy: index ${index} out of range (GROUP BY list has ${items.length} item(s))`,
      );
    }
  }
  await commitEdit({ op: 'remove-group-by', index }, ctx);
}
